import React, {useState, useEffect, useRef, useContext} from "react";
import {useParams, useLocation, useHistory} from "react-router-dom";
import {Grid, Col} from "../../styles/Grid";
import FormPartOne from "./components/FormPartOne";
import styled from "styled-components";
import AppLoader, {LoadComponet} from "../../components/loaders/Loader";
import EditCourseProvider, {EditCourseContext} from "../../context/EditCourseProvider";
import FormPartThree from "./components/FormPartThree";
import FormPartTwo from "./components/FormPartTwo";
import FormPartFour from "./components/FormPartFour";
import FormPartTestimonials from "./components/FormPartTestimonials";

function OfferEditView({theme}) {
   let {id, type} = useParams();
   let location = useLocation();
   let history = useHistory();
   let viewRef = useRef(null);
   const {defaultData, isSaving, isLoadingData, currentTheme} = useContext(EditCourseContext);
   const [addTo, setAdd] = useState(null);
   const [currentPage, setCurrentPage] = useState(2);
   const [isSavingData, setSavingData] = useState(false);

   useEffect(() => {
      searchAdd();
   }, [type]);

   useEffect(() => {
      if (location.state) {
         // setCurrentPage(Number(location.state.page) || 1);
      }
   }, [location]);

   function searchAdd() {
      let newAdd = ConfigArray.find((item) => item.id === Number(type));
      // console.log();
      setAdd(newAdd);
   }

   if (isLoadingData) return <LoadComponet isVisible={true} />;
   if (!defaultData) return null;
   return (
      <>
         <View ref={viewRef}>
            <Grid>
               <Col large={12}>
                  <Grid>
                     <TabSection
                        back={currentTheme.back}
                        className={currentPage === 1 ? "isActive" : ""}
                        onClick={() => {
                           setCurrentPage(1);
                        }}
                     >
                        <span>Datos generales</span>
                     </TabSection>
                     {Number(type) !== 3 && (
                        <>
                           <TabSection
                              back={currentTheme.back}
                              className={currentPage === 2 ? "isActive" : ""}
                              onClick={() => {
                                 setCurrentPage(2);
                              }}
                           >
                              <span>Recursos y vídeos</span>
                           </TabSection>
                           <TabSection
                              back={currentTheme.back}
                              className={currentPage === 3 ? "isActive" : ""}
                              onClick={() => {
                                 setCurrentPage(3);
                              }}
                           >
                              <span>Temario</span>
                           </TabSection>
                           <TabSection
                              back={currentTheme.back}
                              className={currentPage === 4 ? "isActive" : ""}
                              onClick={() => {
                                 setCurrentPage(4);
                              }}
                           >
                              <span>Testimonios</span>
                           </TabSection>
                           <TabSection
                              back={currentTheme.back}
                              className={currentPage === 5 ? "isActive" : ""}
                              onClick={() => {
                                 setCurrentPage(5);
                              }}
                           >
                              <span>Facilitadores</span>
                           </TabSection>
                        </>
                     )}
                  </Grid>
               </Col>
               <Col large={10} offsetL={1}>
                  <PartsContent>
                     <Parts className={currentPage === 1 ? "isActive" : ""}>
                        <FormPartOne continueAction={() => setCurrentPage(2)} data={defaultData} sections={addTo.sections} theme={theme} />
                     </Parts>
                     <Parts className={currentPage === 2 ? "isActive" : ""}>
                        <FormPartTwo
                           data={defaultData}
                           sections={addTo.sections}
                           theme={theme}
                           continueAction={() => {
                              setCurrentPage(3);
                           }}
                           isVisible={currentPage === 2}
                        />
                     </Parts>
                     <Parts className={currentPage === 3 ? "isActive" : ""}>
                        <FormPartThree // temario
                           data={defaultData}
                           sections={addTo.sections}
                           theme={theme}
                           continue={() => {
                              setCurrentPage(4);
                           }}
                        />
                     </Parts>
                     <Parts className={currentPage === 4 ? "isActive" : ""}>
                        <FormPartTestimonials
                           theme={theme}
                           isActive={currentPage === 4}
                           continueAction={() => {
                              setCurrentPage(5);
                           }}
                        />
                     </Parts>
                     <Parts className={currentPage === 5 ? "isActive" : ""}>
                        <FormPartFour
                           data={defaultData}
                           sections={addTo.sections}
                           theme={theme}
                           continueAction={() => {
                              history.goBack();
                           }}
                        />
                     </Parts>
                  </PartsContent>
               </Col>
            </Grid>
         </View>
         <AppLoader isVisible={isSaving} />
         <AppLoader isVisible={isSavingData} />
      </>
   );
}

const OfferEdit = ({theme}) => {
   return (
      <EditCourseProvider>
         <OfferEditView theme={theme} />
      </EditCourseProvider>
   );
};
export default OfferEdit;

const View = styled.div`
   background: white;
   width: 100%;
`;

const PartsContent = styled.div`
   position: relative;
   width: 100%;
`;

const Parts = styled.div`
   width: 100%;
   height: 100%;
   z-index: 0;
   opacity: 0;
   height: 0;
   overflow: hidden;

   &.isActive {
      z-index: 10000000;
      opacity: 1;
      height: auto;
      overflow: initial;
   }
`;

const TabSection = styled.div`
   padding: 0.3em 0.7em;
   font-weight: 300;
   user-select: none;
   color: ${(props) => props.back || "#32529ds"};
   border: 1px inset ${(props) => props.back || "#32529ds"};
   margin-right: 0.5em;
   cursor: pointer;
   transition: all 900ms;

   &.isActive {
      background: ${(props) => props.back || "#32529d"};
      color: white;
      border-color: #32529ds;
      transition: all 420ms;
   }

   &:hover {
      background: ${(props) => props.back || "#32529ds"};
      color: white;
      border-color: grey;
      transition: all 420ms;

      /* &.isActive {
         background: white;
         color: ${(props) => props.back || "#32529ds"};
         border-color: ${(props) => props.back || "#32529ds"};
         transition: all 420ms;
      } */
   }
`;

const ConfigArray = [
   {title: "Cursos esenciales", back: "#af0069", id: 1, sections: [1, 2, 3, 4]},
   {title: "Certificado prime", back: "#8e44ad", id: 2, sections: [1, 2, 3, 4]},
   {title: "Programa emblem", back: "#2980b9", id: 3, sections: [1]},
   {title: "Programa enterprise", back: "#95afc0", id: 4, sections: [1, 2, 3, 4]},
   {title: "Certificado masterclass", back: "#8e44ad", id: 5, sections: [1, 2, 3, 4]},
];
